import { render, staticRenderFns } from "./PatientResult.vue?vue&type=template&id=728d16b6&scoped=true&"
import script from "./PatientResult.vue?vue&type=script&lang=js&"
export * from "./PatientResult.vue?vue&type=script&lang=js&"
import style0 from "./PatientResult.vue?vue&type=style&index=0&id=728d16b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d16b6",
  null
  
)

export default component.exports